import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class JSONGetStringNode extends BaseNode {
    constructor() {
        super();
        this.name = 'JSON Get String';
        this.id = 'node_json_get_string';
        this.icon = 'VscJson';
        this.linkedFeature = 'general';

        this.inputs = [
            {
                name: 'Get',
                portId: 'json_get_string',
                params: [
                ],
            },
        ];

        this.outputs = [
            {
                name: 'Value',
                portId: 'value_output',
                params: [
                    {
                        name: 'json_value',
                        dataType: TibboDataType.STRING,
                        description: 'Value',
                    },
                ],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'JSON_STRING',
                name: 'JSON String',
                settingType: SettingType.STRINGVARIABLE,
                helpText: 'JSON string to get value from e.g. {"key": "value"}',
                required: true,
                default: '',
            },
            {
                id: 'KEY',
                name: 'Key',
                settingType: SettingType.STRINGVARIABLE,
                dataType: TibboDataType.STRING,
                helpText: 'Key in JSON string to get value from e.g. "key"',
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project = this.project;
        const JSON_STRING = this.getSettingValue('JSON_STRING');
        const KEY = this.getSettingValue('KEY');
        const links = project.getNodeLinks(this, 'json_get_string');
        

        const link = links[0];
        const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
        const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;


        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];

            let valueCode = '';
            const valueLinks = project.getNodeLinks(this, 'value_output');
            const valueBlock = valueLinks.length > 0 ? `${project.getCodeLocationStart()}${valueLinks[0].getSourceId()}${project.getCodeLocationEnd()}` : '';
            for (let j = 0; j < valueLinks.length; j += 1) {
                valueCode += `
${valueBlock}`;
            }
    
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    if true then
        dim json_input as string=${project.parseCodeExpression(JSON_STRING, sourceParams, TibboDataType.STRING)}
        dim json_value as string = json_get_value(${project.parseCodeExpression(KEY, sourceParams, TibboDataType.STRING)}, json_input)
        ${valueCode}
    end if
    `,
            });
        }
        return blocks;
    }

    getDetails(): string {
        return `##### Get value from JSON string`;
    }
}
